// @flow

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import { Search } from 'carbon-components-react';
import * as React from 'react';
import { pkg } from '../../../../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var Actions = function Actions(_ref) {
  var searchText = _ref.searchText,
      setSearchText = _ref.setSearchText,
      findColumnPlaceholderLabel = _ref.findColumnPlaceholderLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "__customize-columns-modal--actions")
  }, /*#__PURE__*/React.createElement(Search, {
    placeholder: findColumnPlaceholderLabel,
    value: searchText,
    size: "sm",
    labelText: findColumnPlaceholderLabel,
    onChange: function onChange(e) {
      // TODO: is it performant?
      setSearchText(e.target.value);
    }
  }));
};

Actions.propTypes = {
  columns: PropTypes.array.isRequired,
  findColumnPlaceholderLabel: PropTypes.string,
  originalColumnDefinitions: PropTypes.array.isRequired,
  resetToDefaultLabel: PropTypes.string,
  searchText: PropTypes.string.isRequired,
  setColumnsObject: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired
};
export default Actions;